import React from "react"

import {

  eventsSlidesContent,

  OffersSlidesContent,

  rafSlidesContent,

  sCSlidesContent,

  blastsSlidesContent,

  dripsSlidesContent,

} from "./slidesContent";

import IntroTemplate from "../Templates/introTemplate";

import Template from "../Templates/ScreenTemplate";







export const getSlidesList = (classes, header, slidesContent) => {

  return slidesContent.map((slideContent, index) => {

    if (slideContent.appName) {

      return {

        slide: <IntroTemplate {...slideContent} classes={classes} key={index} />,

        type: "intro",

      };

    }

    return {

      slide: <Template {...slideContent} classes={classes} key={index} />,

      header: header,

    };

  });

};




export const getSlides = (classes, appName) => {

  switch (appName) {

    case "Offers":

      return getSlidesList(classes, "Journey AI Offers", OffersSlidesContent);

    case "Events":

      return getSlidesList(classes, "Journey AI Events", eventsSlidesContent);

    case "Raf":

      return getSlidesList(classes, "Journey AI Suite : Refer-a-Friend", rafSlidesContent);

    case "Blasts":

      return getSlidesList(classes, "Journey AI - Blasts", blastsSlidesContent);

    case "Drips":

      return getSlidesList(classes, "Journey AI - Drips", dripsSlidesContent);

    default:

      return getSlidesList(classes, "Success Center - Blast", sCSlidesContent);

  }

}; 